import { useLocation, useNavigate, Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CouponReveal } from "@/components/CouponReveal";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function Takk() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLang();
  const state = location.state || {};
  const { code, fornavn, alreadyRegistered, codeBrukt, utloper, aktivert, gyldigFra, innlost } = state;

  if (!code) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#1A1715] px-6 text-center">
        <Logo />
        <p className="text-[#A8A29E]">{t("Ingen kupong funnet. Registrer deg for å få din gratis dessert.", "No coupon found. Sign up to get your free dessert.")}</p>
        <button
          onClick={() => navigate("/gave/registrer")}
          className="rounded-full bg-[#D4AF37] px-8 py-3 font-semibold text-[#1A1715] transition-colors hover:bg-[#E5C564]"
          data-testid="go-to-registration-btn"
        >
          {t("Til registrering", "Go to sign-up")}
        </button>
      </div>
    );
  }

  return (
    <CouponReveal
      tittel={t("En gratis dessert", "A free dessert")}
      gyldigFra={gyldigFra}
      fornavn={fornavn}
      utloper={utloper}
      aktivert={aktivert}
      innlost={innlost}
      codeBrukt={codeBrukt}
      heading={`${t("Tusen takk!", "Thank you!")} ❤️`}
      subheading={t(
        `${fornavn ? `${fornavn}, r` : "R"}egistreringen din er fullført. Vi gleder oss til neste besøk!`,
        `${fornavn ? `${fornavn}, y` : "Y"}our sign-up is complete. We look forward to seeing you!`
      )}
      note={alreadyRegistered ? t("Du er allerede registrert. Her er kupongen din.", "You're already registered. Here is your coupon.") : null}
      onActivate={async () => (await api.post("/coupon/activate", { code })).data}
      onRedeem={async () => (await api.post("/coupon/redeem", { code })).data}
      footer={
        <Link to="/gave" className="hover:text-[#D4AF37]" data-testid="back-to-registration">
          ← {t("Til startsiden", "Back to start")}
        </Link>
      }
    />
  );
}
